import { ReactComponent as Signal } from 'design_system/src/static/icons/radio-signal.svg';
import { ReactComponent as NoSignal } from 'design_system/src/static/icons/no-radio-signal.svg';
import { ReactComponent as Home } from 'design_system/src/static/icons/temple.svg';
import { ReactComponent as Hotspot } from 'design_system/src/static/icons/gps.svg';
import { ReactComponent as Account } from 'design_system/src/static/icons/user-circle.svg';

/* eslint-disable no-shadow */
export enum InterestPointType {
	hotspot = 'hotspot',
	signalVehicle = 'signalVehicle',
	noSignalVehicle = 'noSignalVehicle',
	address = 'address',
	geolocation = 'geolocation',
}

export const InterestPointTypeValues = {
	[InterestPointType.signalVehicle]: {
		title: 'Ubicación actual (<24h)',
		score: 4,
		icon: Signal,
		color: 'green',
		realColor: 'green_300',
	},
	[InterestPointType.noSignalVehicle]: {
		title: 'Última ubicación (>24h)',
		score: 1,
		icon: NoSignal,
		color: 'red',
		realColor: 'red_300',
	},
	[InterestPointType.address]: {
		title: 'Domicilio',
		score: 3,
		icon: Home,
		color: 'primary',
		realColor: 'primary_300',
	},
	[InterestPointType.geolocation]: {
		title: 'Ingreso a mi cuenta',
		score: 2,
		icon: Account,
		color: 'secondary',
		realColor: 'secondary_500',
	},
	[InterestPointType.hotspot]: {
		title: 'Hotspot',
		score: 0,
		icon: Hotspot,
		color: 'yellow',
		realColor: 'yellow_100',
	},
};
